/*
 * Pince-moi : diagnostic « Trouver ma pince » (sections/pm-quiz.liquid).
 * Un écran à la fois : introduction → 3 questions → résultat.
 * Le résultat affiché est le premier bloc dont les conditions (ou « any ») correspondent aux réponses.
 */
class PmQuiz extends HTMLElement {
  connectedCallback() {
    this.answers = {};
    this.questions = [...this.querySelectorAll('[data-screen="question"]')];
    this.results = [...this.querySelectorAll('[data-screen="result"]')];
    this.progress = this.querySelector('[data-progress]');
    this.step = -1;

    this.addEventListener('click', (event) => {
      const target = event.target.closest('button');
      if (!target || !this.contains(target)) return;
      if (target.hasAttribute('data-start')) this.go(0);
      else if (target.hasAttribute('data-back')) this.go(this.step - 1);
      else if (target.hasAttribute('data-restart')) {
        this.answers = {};
        this.go(0);
      } else if (target.classList.contains('pm-quiz__option')) this.answer(target);
    });

    this.show(this.querySelector('[data-screen="intro"]'));
  }

  show(screen) {
    this.querySelectorAll('[data-screen]').forEach((s) => (s.hidden = s !== screen));
    const total = this.questions.length + 1;
    const done = this.step < 0 ? 0 : Math.min(this.step, this.questions.length) + (screen?.dataset.screen === 'result' ? 1 : 0);
    if (this.progress) this.progress.style.width = `${(done / total) * 100}%`;
    const focusable = screen?.querySelector('button, a');
    if (this.step >= 0) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      focusable?.focus({ preventScroll: true });
    }
  }

  go(index) {
    if (index < 0) return;
    this.step = index;
    const question = this.questions[index];
    if (question) {
      question.querySelectorAll('.pm-quiz__option').forEach((o) => {
        o.setAttribute('aria-pressed', String(this.answers[question.dataset.key] === o.dataset.value));
      });
      this.show(question);
    } else {
      this.showResult();
    }
  }

  answer(option) {
    const question = option.closest('[data-screen="question"]');
    this.answers[question.dataset.key] = option.dataset.value;
    this.go(this.step + 1);
  }

  showResult() {
    const matches = (result) =>
      ['epaisseur', 'longueur', 'coiffure'].every((key) => {
        const want = result.dataset[key];
        return !want || want === 'any' || want === this.answers[key];
      });
    const result = this.results.find(matches) || this.results[this.results.length - 1];
    this.step = this.questions.length;
    this.show(result);
  }
}

if (!customElements.get('pm-quiz')) {
  customElements.define('pm-quiz', PmQuiz);
}
